export const InventoryHeaderSkeleton = () => {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-4 gap-5 items-stretch animate-pulse">
      
      {/* Left Section Skeleton: Product Details Banner */}
      <div className="xl:col-span-3 bg-gradient-to-r from-white via-slate-50/20 to-white border border-slate-200/60 rounded-2xl p-5 flex flex-col md:flex-row md:items-center justify-between gap-6 relative overflow-hidden">
        
        <div className="flex items-center gap-5 min-w-0 flex-1">
          {/* Visual Product Box Placeholder */}
          <div className="w-16 h-16 bg-slate-200/60 border border-slate-200/30 rounded-xl flex-shrink-0" />

          {/* Identity Information and Meta Strings */}
          <div className="space-y-2.5 min-w-0 flex-1">
            {/* UPC Pill Badge Placeholder */}
            <div className="h-5 w-28 bg-slate-200/80 rounded-full" />
            
            {/* Product Title Placeholder */}
            <div className="h-6 w-3/4 max-w-sm bg-slate-300/70 rounded-md" />

            {/* Description Line Placeholder */}
            <div className="h-3.5 w-5/6 max-w-md bg-slate-200/50 rounded-md" />
          </div>
        </div>

        {/* Right Section Skeleton: Location Route Tags */}
        <div className="flex items-center justify-between md:justify-end gap-6 md:pl-6 md:border-l border-slate-200/60 shrink-0">
          <div className="space-y-2.5">
            {/* Context Label Placeholder */}
            <div className="h-3 w-32 bg-slate-200/40 rounded" />
            
            {/* Route Badges Track Placeholder */}
            <div className="flex items-center gap-2">
              <div className="h-7 w-24 bg-slate-200/60 rounded-lg" />
              <div className="h-3.5 w-3.5 bg-slate-200/40 rounded animate-ping duration-1000" />
              <div className="h-7 w-28 bg-slate-200/60 rounded-lg" />
            </div>
          </div>
        </div>
      </div>

      {/* Right Section Skeleton: Mirroring Total Scanned Metric Card */}
      <div className="bg-white border border-slate-200/70 rounded-2xl p-5 flex items-center justify-between relative overflow-hidden">
        <div className="space-y-2.5 flex-1">
          {/* Label Title Placeholder */}
          <div className="h-3 w-28 bg-slate-200/60 rounded" />
          
          {/* Counter Text Placeholder */}
          <div className="flex items-baseline gap-1.5">
            <div className="h-9 w-14 bg-slate-300/60 rounded-md" />
            <div className="h-2.5 w-8 bg-slate-100 rounded" />
          </div>
        </div>

        {/* Layer Icon Box Placeholder */}
        <div className="w-12 h-12 rounded-xl bg-slate-200/50 border border-slate-100 shrink-0" />
      </div>

    </div>
  );
};